import React, { memo } from "react";
import Head from 'next/head';
import NewsContainer from "containers/NewsContainer";

import { quizListUrl, getNewsUrl } from "utils/api/requestUrls";

const NewsPage = (props: any) => {
  return <>
    <Head>
      <title>Новости от экспертов по квестам в реальности - Old Mouse</title>
      <meta name="description" content={"Интересуетесь квестами? Мы подготовили для вас список полезных статей о квеструмах!"} />
    </Head>
    <NewsContainer {...props} />;
  </>
};

export const getServerSideProps = async (context) => {
  const { req, res } = context;

  const questListResponse = await fetch(quizListUrl(null, null));
  const questListFirstData = await questListResponse.json();

  const newsResponse = await fetch(getNewsUrl);
  const newsFirstData = await newsResponse.json();

  if (req.headers.host.match(/^www/) !== null) {
    res.writeHead(301, {
      location: "https://" + req.headers.host.replace(/^www./, "") + req.url,
    });
    res.end();
  }

  return {
    props: {
      questListFirstData: questListFirstData?.content,
      newsFirstData: newsFirstData
    },
  };
};

export default memo(NewsPage);
